import { createContext, useCallback, useContext } from 'react';
import {
  toast,
  ToastContainer,
  ToastOptions,
  ToastPosition,
} from 'react-toastify';
import CloseButton from '@c/icons/buttons/CloseButton';

interface ToastContext {
  showToast: (content: JSX.Element, options?: ToastOptions<{}>) => void;
  showSuccessToast: (text: string, position?: ToastPosition) => void;
  showErrorToast: (
    text: string,
    position?: ToastPosition,
    duration?: number
  ) => void;
}
const ToastContext = createContext({} as ToastContext);
export function useToastContext() {
  return useContext(ToastContext);
}

const CustomCloseButton = () => {
  return (
    <div className="ml-[1.6rem] mr-[1.6rem] flex flex-col items-center justify-center">
      <CloseButton />
    </div>
  );
};
export function ToastProvider({ children }: any) {
  const showToast = useCallback(
    (content: JSX.Element, options?: ToastOptions<{}> | undefined) => {
      toast(content, options);
    },
    []
  );

  const showSuccessToast = (
    text: string,
    position: ToastPosition = 'top-center',
    duration: number = 1500
  ) => {
    toast.success(text, {
      position,
      autoClose: duration,
      hideProgressBar: true,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
      theme: 'colored',
      closeButton: true,
      style: {
        background: '#0FCE5B',
        color: '#fff',
      },
    });
  };

  const showErrorToast = (
    text: string,
    position: ToastPosition = 'top-center',
    duration: number = 1500
  ) => {
    toast.error(text, {
      position,
      autoClose: duration,
      hideProgressBar: true,
      closeOnClick: true,
      rtl: false,
      pauseOnFocusLoss: true,
      draggable: true,
      pauseOnHover: true,
      theme: 'colored',
      closeButton: true,
      style: {
        background: '#CC0000',
        color: '#fff',
      },
    });
  };

  return (
    <ToastContext.Provider
      value={{
        showToast,
        showSuccessToast,
        showErrorToast,
      }}
    >
      <ToastContainer
        position="top-center"
        autoClose={1500}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        closeButton={<CustomCloseButton />}
      />
      {children}
    </ToastContext.Provider>
  );
}
